import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';





Vue.config.productionTip = false;

import VueGtag from "vue-gtag";

Vue.use(VueGtag, {
   config: { id: "UA-102056363-1" }
}, router);



window.app = new Vue({
  router,
  store,
  vuetify,
  render: function (h) { return h(App) }
}).$mount('#app');


